import {QUESTIONS_PARTNERS} from '../../../constants/questionsPartners';
import {P_LIST_TYPES, PARTNERS_TYPES} from '../../../constants/typesMessages';
import {selectMessage} from '../getPartnerMessages/getPartnerMessages';
import {isEmptyPartnersList} from '../partnersDataValidations/partnersDataValidations';

/**
 * Partners Start
 */

const getFirstQuestionPartners = (partner, quizPartners, typePartner) => {
  let fQ = QUESTIONS_PARTNERS.find(
    (question) => question.idQuestion === quizPartners[0].idQuestion
  );

  let showText = setTextMessagePartners(typePartner, fQ, partner);

  return {
    messages: [
      {
        text: showText,
        partnerId: partner.id,
        type: fQ.type
      }
    ],
    partner: partner,
    responseFlow: '',
    responseType: fQ.responseTypeChange
  };
};

/**
 * Quando tem/nao tem dados de sócios ou sócias no Bureau
 */
export const quizPartnersStart = (
  ec,
  quizPartners,
  partnersTypeList,
  partnerSelected
) => {
  let messages = [];
  let responseFlow = '';
  let responseType = '';
  let selectedPartner = {};

  if (isEmptyPartnersList(ec)) {
    return {
      messages: [
        {
          text: 'Você é o(a) proprietário(a) do estabelecimento?',
          type: PARTNERS_TYPES.IS_OWNER
        }
      ],
      selectedPartner,
      responseType: 'disabled',
      responseFlow
    };
  }

  messages.push({
    text: selectMessage(partnersTypeList),
    type: 'message-receive'
  });

  const quiz = getFirstQuestionPartners(
    // ec.partners[0],
    partnerSelected,
    quizPartners,
    partnersTypeList
  );

  messages.push(...quiz.messages);
  selectedPartner = quiz.partner;
  responseFlow = quiz.responseFlow;
  responseType = quiz.responseType;

  return {messages, selectedPartner, responseType, responseFlow};
};

/**
 * Get next question partners
 */

const filterQuestionsList = (idQuestion, quizPartners) => {
  let nextQuestions = quizPartners.filter(
    (question) => question.idQuestion > idQuestion
  );

  if (nextQuestions.length === 0) {
    return {...quizPartners[0], nextPartner: true};
  }

  return {...nextQuestions[0], nextPartner: false};
};

const getNextPartner = (partnersList, partnerSel) => {
  let nextPartnersList = partnersList.filter(
    (partner) => partner.id > partnerSel.id
  );

  if (nextPartnersList.length === 0) return {stop: true};

  return {partner: nextPartnersList[0], stop: false};
};

const setTextMessagePartners = (typePartner, question, partnerSel) => {
  switch (typePartner) {
    case P_LIST_TYPES.P_OWNER:
      return question.fromOwner;

    case P_LIST_TYPES.P_EMPTY: {
      if (question.fromEmptyPartnerHasName) {
        return `${question.fromEmptyPartner} ${partnerSel.partnerName}?`;
      } else {
        return question.fromEmptyPartner;
      }
    }

    case P_LIST_TYPES.P_OWN_HAS_PART:
      return question.fromOwner;

    default:
      return `${question.fromPartner} ${partnerSel.partnerName}?`;
  }
};

const textNextPartnerFill = (partnersTypeList, partnerSel, flow) => {
  let text = `Ótimo, preenchemos os dados de ${partnerSel.partnerName}, `;
  text += 'agora vamos para os dados';

  return partnersTypeList === P_LIST_TYPES.P_EMPTY
    ? `${text} do próximo(a) sócio(a) da sua empresa.`
    : `${text} de ${flow.partner.partnerName}.`;
};

const getInfoPartner = (partnersList, partnerSel) => {
  return partnersList.find((partner) => partner.id === partnerSel.id);
};

/**
 * Only the first position in the member array can be of type `P_LIST_TYPES.P_OWNER`
 */
const firstPositionIsBeingFilled = (partnerId, partnersTypeList) => {
  if (partnerId === 1) {
    if (
      partnersTypeList === P_LIST_TYPES.P_OWNER ||
      partnersTypeList === P_LIST_TYPES.P_OWN_HAS_PART
    ) {
      partnersTypeList = P_LIST_TYPES.P_EMPTY;
    }
  }

  return partnersTypeList;
};

export const getNextPartnerQuestion = (
  idQuestion,
  quizPartners,
  partnersList,
  partnerSel,
  partnersTypeList
) => {
  let messages = [];
  let partnersComplete = false;
  let nextQuestionType = filterQuestionsList(idQuestion, quizPartners);
  let nextQuestion = QUESTIONS_PARTNERS.find((question) => {
    return question.idQuestion === nextQuestionType.idQuestion;
  });
  partnerSel = getInfoPartner(partnersList, partnerSel);

  if (nextQuestionType.nextPartner) {
    let flow = getNextPartner(partnersList, partnerSel);
    if (flow.stop) {
      partnersComplete = true;
    } else {
      partnersTypeList = firstPositionIsBeingFilled(
        flow.partner.id,
        partnersTypeList
      );

      messages.push({
        text: textNextPartnerFill(partnersTypeList, partnerSel, flow),
        type: 'message-receive'
      });

      partnerSel = flow.partner;
    }
  }

  if (partnersComplete) {
    messages.push({
      text: 'Perfeito! Continuemos com seu credenciamento...',
      type: 'message-receive'
    });
  } else {
    let showText = setTextMessagePartners(
      partnersTypeList,
      nextQuestion,
      partnerSel
    );
    messages.push({
      text: showText,
      type: nextQuestion.type
    });
  }

  return {
    ...nextQuestion,
    nextPartner: nextQuestionType.nextPartner,
    partner: partnerSel,
    partnersComplete,
    messages,
    partnersTypeList
  };
};
